/* fiveaven (18/10/2026, demandes d'Andy) : défilement PROGRESSIF des bandeaux de produits et de vidéos.
   « Vous aimerez aussi » et « Vous en parlez mieux que nous » deviennent des bandes qui défilent en continu, comme une page :
   deux doigts sur le pavé tactile, doigt sur mobile, souris maintenue, et les flèches avancent en douceur (au lieu de sauter
   une rangée entière). Le carrousel du thème (Splide) reste en place mais n'anime plus la bande : le navigateur la fait défiler.
   Ailleurs (autres carrousels), un glissement horizontal au pavé actionne les flèches. */
(() => {
  const NATIFS = '[id*="product-recommendations"] .splide, [id*="video_shopping"] .splide';
  const racineNative = (el) => { const r = el && el.closest && el.closest('.splide.fv-defile'); return r && r.matches(NATIFS) ? r : null; };
  const piste = (r) => r.querySelector(':scope > .splide__track') || r.querySelector('.splide__track');
  const fleches = (r) => {
    for (let n = r, i = 0; n && i < 4; n = n.parentElement, i++) {
      const p = n.querySelector('.splide__arrow--prev'), s = n.querySelector('.splide__arrow--next');
      if (p || s) return [p, s];
    }
    return [null, null];
  };
  const etat = (r) => {
    const t = piste(r); if (!t) return;
    const max = t.scrollWidth - t.clientWidth;
    const [p, s] = fleches(r);
    if (p) p.disabled = t.scrollLeft <= 2;
    if (s) s.disabled = t.scrollLeft >= max - 2;
    const zone = r.closest('.shopify-section') || r.parentElement;
    const barre = zone && zone.querySelector('.splide-progress-bar');
    if (barre) barre.style.width = (t.scrollWidth ? Math.min(100, (t.scrollLeft + t.clientWidth) / t.scrollWidth * 100) : 100) + '%';
  };
  const preparer = () => document.querySelectorAll(NATIFS).forEach((r) => {
    if (r.classList.contains('fv-defile') || (r.parentElement && r.parentElement.closest('.splide'))) return; // seulement la bande, pas les petits carrousels d'images des cartes
    const t = piste(r); if (!t) return;
    r.classList.add('fv-defile');
    t.addEventListener('scroll', () => etat(r), { passive: true });
    addEventListener('resize', () => etat(r), { passive: true });
    etat(r);
  });

  // flèches : défilement doux d'environ une largeur d'écran de la bande, au lieu du saut du carrousel
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('.splide__arrow');
    if (!b) return;
    const zone = b.closest('.shopify-section');
    const r = b.closest('.splide.fv-defile') || (zone && zone.querySelector('.splide.fv-defile'));
    if (!r) return;
    e.preventDefault(); e.stopImmediatePropagation();
    const t = piste(r);
    t.scrollBy({ left: (b.classList.contains('splide__arrow--next') ? 1 : -1) * t.clientWidth * 0.85, behavior: 'smooth' });
  }, true);

  // le carrousel du thème ne doit plus capter le doigt ni la souris sur ces bandes (sinon il bloque le défilement natif)
  let glisse = null, aBouge = false;
  const garde = (e) => {
    const r = racineNative(e.target);
    if (!r || !(e.target.closest('.splide__track'))) return; // y compris les petits carrousels d'images des cartes : seule la bande défile
    e.stopPropagation();
    if (e.type === 'mousedown' && e.button === 0) { const t = piste(r); glisse = { t, x: e.clientX, g: t.scrollLeft }; aBouge = false; }
  };
  ['touchstart', 'touchmove', 'touchend', 'mousedown'].forEach((type) => document.addEventListener(type, garde, { capture: true, passive: true }));
  // souris : bande attrapée et tirée, comme au doigt
  document.addEventListener('mousemove', (e) => {
    if (!glisse) return;
    const dx = e.clientX - glisse.x;
    if (Math.abs(dx) > 5) aBouge = true;
    if (aBouge) { glisse.t.scrollLeft = glisse.g - dx; e.stopPropagation(); }
  }, true);
  document.addEventListener('mouseup', () => { if (glisse && aBouge) { const stop = (ev) => { ev.preventDefault(); ev.stopImmediatePropagation(); }; document.addEventListener('click', stop, { capture: true, once: true }); setTimeout(() => document.removeEventListener('click', stop, true), 0); } glisse = null; }, true);

  // autres carrousels : glissement horizontal au pavé = flèches (les bandes ci-dessus défilent seules, sans ce relais)
  const SEUIL = 40, PAUSE = 380;
  let cumul = 0, bloque = 0, dernier = null;
  const visible = (b) => b && b.offsetParent !== null;
  const flechesVisibles = (racine) => [...racine.querySelectorAll('.splide__arrow')].filter((b) => b.closest('.splide') === racine && visible(b));
  document.addEventListener('wheel', (e) => {
    if (Math.abs(e.deltaX) <= Math.abs(e.deltaY) || racineNative(e.target)) return;
    let c = null;
    for (let r = e.target.closest && e.target.closest('.splide'); r; r = r.parentElement && r.parentElement.closest('.splide')) {
      const l = flechesVisibles(r); if (l.length) { c = { r, s: l.find((b) => /--next/.test(b.className)), p: l.find((b) => /--prev/.test(b.className)) }; break; }
    }
    if (!c) return;
    e.preventDefault();
    if (c.r !== dernier) { cumul = 0; dernier = c.r; }
    const t = performance.now();
    if (t < bloque) return;
    cumul += e.deltaX;
    if (Math.abs(cumul) < SEUIL) return;
    const b = cumul > 0 ? c.s : c.p; cumul = 0;
    if (b && !b.disabled) { b.click(); bloque = t + PAUSE; }
  }, { passive: false });

  // les bandes arrivent parfois après le chargement (« Vous aimerez aussi » est chargé à part)
  let attente = false;
  const plusTard = () => { if (attente) return; attente = true; requestAnimationFrame(() => { attente = false; preparer(); }); };
  const go = () => { preparer(); new MutationObserver(plusTard).observe(document.body, { childList: true, subtree: true }); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', go) : go();
})();
